//
// Este es el componente raíz de la aplicación React. Se encarga de definir
// la estructura de enrutamiento principal utilizando `react-router-dom`,
// registrando todas las rutas del sitio y asociándolas con sus respectivos
// componentes de pantalla. También utiliza `React.lazy` para la carga diferida
// de componentes, optimizando el rendimiento inicial de la aplicación.
//
// Punto de entrada de la aplicación React.
// Define el router principal y registra todas las rutas disponibles del sitio.
// HelmetProvider envuelve todo para que cada página pueda gestionar sus propias meta tags de SEO.

// Carga diferida (lazy) para rutas que NO necesitan estar en el bundle inicial.
// Reduce el JS que se parsea en la home page: FormPage y SinglePostPage
// son ~15 KiB que el usuario de la home nunca va a necesitar de entrada.
import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// Rutas principales: se incluyen en el bundle inicial (se muestran con frecuencia)
import Directorio from './screens/directorio/directorio';
import DataAnalisys from './screens/Tecnico/data-analisys/data-analisys';
import TeatroLanding from './screens/Creativo/teatro/TeatroLanding';
import PerfumeriaLanding from './screens/Creativo/perfumeria/perfumeria';
import NotFound from './screens/not-found/not-found';

// Rutas lazy: se cargan sólo cuando el usuario navega a ellas
const TeatroColon     = lazy(() => import('./screens/Creativo/teatro/TeatroColonLanding'));
const SinglePostPage  = lazy(() => import('./screens/single-post-page/single-post-page'));
const FormPage        = lazy(() => import('./screens/form-page/form-page'));
const ProductPage     = lazy(() => import('./screens/product-page/product-page'));
const SectionPage     = lazy(() => import('./screens/section-page/section-page'));
const Pruebas         = lazy(() => import('./screens/pruebas/pruebas'));

// Registra cada ruta con su componente de pantalla correspondiente
const App = () => {
  return (
    <HelmetProvider>
      <Router>
        <Suspense fallback={null}>
          <Routes>
            {/* Página principal: índice de áreas del portafolio */}
            <Route path="/" element={<Directorio />} />

            {/* Sección técnica */}
            <Route path="/data" element={<DataAnalisys />} />

            {/* Secciones creativas */}
            <Route path="/teatro" element={<TeatroLanding />} />
            <Route path="/teatrocolon" element={<TeatroColon />} />
            <Route path="/perfumeria" element={<PerfumeriaLanding />} />

            {/* Formulario público de suscripción (Teatro / Perfumería) */}
            <Route path="/form" element={<FormPage />} />

            {/* Página de detalle de cualquier post de Ghost */}
            <Route path="/post/:slug" element={<SinglePostPage />} />

            {/* Página de detalle de un producto del ecommerce */}
            <Route path="/producto/:slug" element={<ProductPage />} />

            {/* Página genérica de una sección creada desde el admin */}
            <Route path="/seccion/:slug" element={<SectionPage />} />

            {/* Página OCULTA de previsualización: notas con tag 'pruebas' (noindex, sin links) */}
            <Route path="/pruebas" element={<Pruebas />} />

            {/* Captura cualquier ruta no definida y muestra el 404 */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </Router>
    </HelmetProvider>
  );
};

export default App;
